// eslint-disable-next-line no-redeclare
import _ from 'lodash';

/**
 * Service to handle VAT (Value Added Tax) related functions.
 */
angular.module('hjApp').service('VAT', [
    function () {
        /*************************
         * PUBLIC ACCESS FUNCTIONS
         *************************/

        /**
         * Check if VAT applies to the country code specified.
         *
         * @param isoCountryCode {string} Country code to check.
         */
        this.appliesToCountry = function (isoCountryCode) {
            return this.rate(isoCountryCode) > 0;
        };

        /**
         * VAT countries to whom reverse charge does not apply.
         * Reverse charge is the process of charging 0% VAT when a VAT number is provided.
         *
         * @param isoCountryCode {string} Country code to check.
         */
        this.reverseChargeInapplicable = function (isoCountryCode) {
            var countries = ['MT', 'RU'];

            return _.includes(countries, this.isoToVatCountryCode(isoCountryCode));
        };

        /**
         * Return the applicable VAT rate of a country. Returns 0 if VAT does not apply.
         *
         * @param isoCountryCode {string} VAT country code to get the VAT rate for.
         */
        this.rate = function (isoCountryCode) {
            var rates = {
                AT: 20,
                BE: 21,
                BG: 20,
                HR: 25,
                CL: 19,
                CY: 19,
                CZ: 21,
                DK: 25,
                EE: 20,
                FI: 24,
                FR: 20,
                DE: 19,
                EL: 24,
                HU: 27,
                IE: 23,
                IT: 22,
                LV: 21,
                LT: 21,
                LU: 17,
                MT: 18,
                NL: 21,
                PL: 23,
                PT: 23,
                RO: 19,
                RU: 20,
                SK: 20,
                SI: 22,
                ES: 21,
                SE: 25,
                GB: 20,
                SG: 7
            };

            return rates[this.isoToVatCountryCode(isoCountryCode)] || 0;
        };

        /**
         * Convert an ISO country code to a VAT based one.
         * The VAT country code is not strictly the same as ISO 3166-1.
         *
         * @param isoCountryCode {string} Country code to convert.
         *
         */
        this.isoToVatCountryCode = function (isoCountryCode) {
            var isoToVat = {
                GR: 'EL'
            };

            return isoToVat[isoCountryCode] || isoCountryCode;
        };
    }
]);
